import React from 'react';
import PropTypes from 'prop-types';
import Select from '../Select';
import {
  REPORT_TYPES,
  STANDARD_SUB_REPORT_TYPES
} from '../../../constants/reportLayouts';


const ReportTypeDropdown = ({ value, onChange, standardSub=false }) => (
  <Select
    value={value}
    onChange={onChange}
    options={standardSub ? STANDARD_SUB_REPORT_TYPES : Object.values(REPORT_TYPES)}
  />
);

ReportTypeDropdown.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  standardSub: PropTypes.bool
};

export default ReportTypeDropdown;


// WEBPACK FOOTER //
// src/components/shared/ReportTypeDropdown/index.jsx